import { Component, Input, OnInit } from '@angular/core';
import { GLOBAL_ERROR_MESSAGES } from '@app/shared/data/messages';

@Component({
    selector: 'bh-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.scss'],
    standalone: false
})
export class StatusComponent implements OnInit {

  @Input() state: string | null = null;
  @Input() message: string | null = null;
  @Input() showNote?: boolean = false;
  genericNote = GLOBAL_ERROR_MESSAGES.REACH_OUT_US;

  constructor() { }

  ngOnInit(): void { 
    // no initial operations required
  }

}
